import script from "./PersonalDataPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalDataPage.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalDataPage.vue?vue&type=style&index=0&id=0526a0f9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0526a0f9"]])

export default __exports__